import { AuthConstants as Constants } from '../constants'
import { authApi as api } from '../../api'

export const authAction = {
    login,
    logout,
    clear,
    auth_check,
    me,
};

function login(form_data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._login(form_data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure('Failed'));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.LOGIN, payload } }
    function failure(error) { return { type: Constants.FAILED, error } }
}

function auth_check() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._auth_check()
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure('Failed'));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.LOGIN, payload } }
    function failure(error) { return { type: Constants.FAILED, error } }
}

function logout() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._logout()
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure('Failed'));
                        reject(error)
                    }
                )
        });
    function success() { return { type: Constants.LOGOUT } }
    function failure() { return { type: Constants.LOGOUT_FAILED } }
    }
}

function clear() {
    
    return dispatch => {   
        return new Promise((resolve, reject) => {     
            dispatch(success());
            resolve()
        })   
    }
    function success() { return { type: Constants.CLEAR } }
}

function me() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._me()
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure('Failed'));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.ME, payload } }
    function failure(error) { return { type: Constants.FAILED, error } }
}